/* stylelint-disable property-no-vendor-prefix */
/* stylelint-disable value-no-vendor-prefix */
import styled from 'styled-components';

import {
  BodySmall,
  H5,
} from '@/core/components/Typography';

import { breakpoint } from '@/themes/breakpoints';

export const CardsGrid = styled.div`
  overflow: hidden;
  display: flex;
  flex-direction: column;
  white-space: nowrap;

  @media ${breakpoint.xs} {
    display: grid;
    grid-template-columns: repeat(1, 1fr);
  }

  @media ${breakpoint.sm} {
    grid-template-columns: repeat(4, 1fr);
  }

  @media ${breakpoint.md} {
    grid-template-columns: repeat(6, 1fr);
  }
  /* stylelint-disable order/properties-order */
  gap: 16px;
`;

export const FeaturedCard = styled.a`
  display: flex;
  flex-direction: column;
  text-decoration: none;
  cursor: pointer;

  @media ${breakpoint.xs} {
    grid-column: auto / span 2;
  }

  @media ${breakpoint.md} {
    :nth-child(1),
    :nth-child(2) {
      grid-column: auto / span 3;
    }
  }
`;

export const Header = styled.h5`
  ${H5}
  overflow: hidden;
  margin: 0;
  margin-top: 24px;
  color: ${({ theme }) => theme.colors.black};
  white-space: initial;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
  -webkit-line-clamp: 2;
`;

export const SubHeader = styled.p`
  ${BodySmall}
  overflow: hidden;
  margin: 0;
  margin-top: 8px;
  color: ${({ theme }) => theme.colors.neutral[700]};
  line-height: 24px;
  text-overflow: ellipsis;
`;

export const RowContainer = styled.div`
  overflow: hidden;
  display: flex;
  align-items: center;
  margin: 0;
  margin-top: 16px;
  text-overflow: ellipsis;
`;
